import { format, formatDistanceToNowStrict } from "date-fns";
import { ms } from "date-fns/locale";
import { Loader2, Moon, Timer } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { estimateFinish, inQuiet } from "@/lib/helper";

// Live progress of today's background posting + estimated finish time.
export default function BgProgress({ srv, auto, now }) {
  if (!srv) return null;
  const finished = srv.today_done + srv.today_failed;
  const limitLeft = auto?.dailyLimit > 0 ? Math.max(0, auto.dailyLimit - (auto.count || 0)) : Infinity;
  const remaining = auto?.enabled ? Math.min(srv.due_groups, limitLeft) : srv.due_groups;
  const deferred = srv.due_groups - remaining;
  const total = finished + remaining;
  if (total === 0 || (remaining === 0 && !auto?.running)) return null;
  const pct = Math.round((finished / total) * 100);
  const eta = estimateFinish(auto, remaining, now);
  const quiet = auto?.enabled && !auto.running && inQuiet(auto.quiet, new Date(now));

  return (
    <div className="mt-5 rounded-lg border border-indigo-500/30 bg-indigo-500/5 p-4" data-testid="dash-bg-progress">
      {auto?.running && auto.currentGroup ? (
        <p className="mb-2 flex items-center gap-2 text-sm text-emerald-200" data-testid="dash-bg-current">
          <Loader2 className="h-4 w-4 shrink-0 animate-spin" /> Sedang post: <b className="truncate">{auto.currentGroup}</b>
          <span className="font-mono text-xs text-muted-foreground">{Math.max(0, Math.round((now - auto.runningSince) / 1000))}s</span>
        </p>
      ) : quiet ? (
        <p className="mb-2 flex items-center gap-2 text-sm text-indigo-200" data-testid="dash-bg-current"><Moon className="h-4 w-4 shrink-0" /> Waktu rehat hingga {auto.quiet.end} - akan sambung selepas itu</p>
      ) : null}
      <div className="mb-2 flex flex-wrap justify-between gap-2 font-mono text-xs text-muted-foreground">
        <span data-testid="dash-bg-progress-count">{finished} / {total} group selesai hari ini · baki {remaining}</span>
        <span data-testid="dash-bg-progress-pct">{pct}%</span>
      </div>
      <Progress value={pct} className="h-2.5" data-testid="dash-bg-progress-bar" />
      <p className="mt-2 flex items-center gap-1.5 text-xs text-muted-foreground" data-testid="dash-bg-eta">
        <Timer className="h-3.5 w-3.5 shrink-0" />
        {eta
          ? <>Anggaran siap <b className="text-slate-200">{formatDistanceToNowStrict(eta, { locale: ms, addSuffix: true })}</b> (sekitar {format(eta, "h:mm a")})</>
          : auto?.enabled === false ? "Mod Latar MATI - hidupkan untuk mula post." : "Anggaran masa hanya tersedia di Chrome yang dipasang Helper."}
      </p>
      {deferred > 0 && <p className="mt-1 text-xs text-amber-200" data-testid="dash-bg-deferred">{deferred} group lagi disambung esok (had harian {auto.dailyLimit}).</p>}
    </div>
  );
}
